$(function () {
  const requiredIfActive = 'required-if-active';

  function isRequired (value, element) {
    if (!element.dataset.valRequiredIfActive) {
      return false;
    }

    const targetSelector = element.dataset.valRequiredIfActiveTarget;
    const targetChecked = $(targetSelector).prop('checked');

    if (targetChecked === undefined) {
      return false;
    }

    return targetChecked;
  }

  // Front end validation to prevent submitting HTML
  const preventHtmlReg = new RegExp('<[a-zA-Z!/?]+|&#');
  $.validator.addMethod(
    'preventhtml',
    function (value, element) {
      const result = preventHtmlReg.exec(value);

      if (!result) {
        return true;
      }

      $(element).data(
        'data-preventhtml-error-message',
        $('<div/>').text(result[0]).html()
      );
      return false;
    },
    function (params, element) {
      return (
        'Input can not contain HTML: ' +
        $(element).data('data-preventhtml-error-message')
      );
    }
  );

  // Front end validation for conditionally required fields
  $.validator.addMethod(
    requiredIfActive,
    function (value, element) {
      return !(isRequired(value, element) && value === '');
    },
    'Input is required'
  );

  // Front end validation to force date input to be in the future
  $.validator.addMethod(
    'future-date',
    function (value, element) {
      return !isRequired(value, element)
        ? true
        : moment(value, element.dataset.valFutureDate).isAfter(moment());
    },
    ' Date must be after today'
  );

  // Front end validation to force date format
  $.validator.addMethod(
    'date-format',
    function (value, element) {
      return !isRequired(value, element)
        ? true
        : moment(value, element.dataset.valDateFormat).isValid();
    },
    $.validator.format('Date must be in format {0}')
  );

  // Add unobtrusive adapter to use validator rule
  $.validator.unobtrusive.adapters.add('date-format', [], function (options) {
    options.rules['date-format'] = options.message;
  });

  // Add unobtrusive adapter to use validator rule
  $.validator.unobtrusive.adapters.add('future-date', [], function (options) {
    options.rules['future-date'] = true;
  });

  // Add unobtrusive adapter to use validator rule
  $.validator.unobtrusive.adapters.add(requiredIfActive, [], function (
    options
  ) {
    options.rules[requiredIfActive] = true;
    options.messages[requiredIfActive] = options.message;
  });

  // Add unobtrusive adapter to use validator rule
  $.validator.unobtrusive.adapters.add('preventhtml', [], function (options) {
    options.rules['preventhtml'] = true;
  });
});
